import { useFishDetails } from '../FishDetailsContext';
import { GuestTabRail } from '@Components/Guest';
import { Card } from '@Components/Card/index';
import ActivityList from '@Components/ActivityList';
import InteractionList from '@Components/InteractionList';
import LoadingSpinner from '@Components/LoadingSpinner';
import { Switch } from '@Components/Switch/index';

const SUB_TABS = [
  { value: 'history', label: 'History' },
  { value: 'upcoming', label: 'Upcoming' },
  { value: 'interactions', label: 'Interactions' },
  { value: 'admin', label: 'Admin' },
];

export default function ActivityPanel({ subTab, onSubTabChange }) {
  const {
    activity,
    interactions,
    isLoading,
    isActivityLoading,
    openModal,
    setModalContent,
    setReceiptData,
    showCancelled,
    setShowCancelled,
    upcomingActivityCount,
  } = useFishDetails();

  return (
    <div className="flex flex-col gap-4">
      <GuestTabRail
        tabs={SUB_TABS.map((tab) =>
          tab.value === 'upcoming' && upcomingActivityCount > 0
            ? { ...tab, label: `${tab.label} (${upcomingActivityCount})` }
            : tab,
        )}
        activeTab={subTab}
        onTabChange={onSubTabChange}
        className="scrollbar-dark overflow-x-auto border-b border-aoh-border dark:border-zinc-700"
      />

      {subTab === 'history' && (
        <>
                  <div className="flex items-center justify-end px-4 pt-2">
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-aoh-muted dark:text-zinc-400">Show Cancelled</span>
                      <Switch
                        className="data-[state=checked]:bg-aoh-accent dark:data-[state=checked]:bg-primary"
                        checked={showCancelled}
                        onCheckedChange={setShowCancelled}
                      />
                    </div>
                  </div>
                  {isLoading || isActivityLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <div className="pt-4">
                      <ActivityList
                        activity={activity}
                        future={false}
                        title={'history'}
                        setModalContent={setModalContent}
                        openModal={openModal}
                        setReceiptData={setReceiptData}
                      />
                    </div>
                  )}
        </>
      )}

      {subTab === 'upcoming' && (
        <>
                  {isLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <div className="pt-4">
                      <ActivityList
                        activity={activity}
                        future={true}
                        title={'upcoming'}
                        setModalContent={setModalContent}
                        openModal={openModal}
                        setReceiptData={setReceiptData}
                      />
                    </div>
                  )}
        </>
      )}

      {subTab === 'interactions' && (
        <div className="pt-4">
          <Card className="min-h-[150px] p-4">
            {!interactions?.length && (
              <div className="flex h-[50px] items-center pt-6">
                <div className="text-3xl">|</div>
                <div className="pl-8">No interactions were found.</div>
              </div>
            )}

            <InteractionList interactions={interactions} />
          </Card>
        </div>
      )}

      {subTab === 'admin' && (
        <>
                  {isLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <div className="pt-4">
                      <ActivityList
                        activity={activity}
                        future={false}
                        admin={true}
                        title={'upcoming'}
                        setModalContent={setModalContent}
                        openModal={openModal}
                        setReceiptData={setReceiptData}
                      />
                    </div>
                  )}
        </>
      )}
    </div>
  );
}
